<template>
  <div class="tour-days-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane name="tour_day">
            <div slot="label">
              Lịch trình
              <span>({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div style="display: flex; align-items: center;">
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            class="mr-2"
            @click="createTag"
          >Thêm</el-button>
          <import-excel-button
            class="mr-2"
            size="small"
            :disabled="loading"
            :total="total"
            :columns="excelColumns"
            :type="'tour_day'"
            :titles="importExportTitles"
            :active-tab="'tour_day'"
            @reload="handleChangeTab"
          />
          <export-excel-button
            class="mr-2"
            size="small"
            :disabled="loading"
            :total="total"
            :columns="excelColumns"
            :type="'tour_day'"
            :titles="importExportTitles"
            :active-tab="'tour_day'"
          />
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            size="small"
            @click="handleChangeTab"
          >Làm mới</el-button>
        </div>
      </div>
    </el-row>
    <list-tour-days
      :loading="loading"
      :data="allArtifacts"
      @reload="handleReloadAfterDelete"
      @update="updateTag"
    ></list-tour-days>
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
    <schedule-popup
      v-if="formVisible"
      :visible="formVisible"
      :data="selectedTourDay"
      @close="formVisible = false"
      @reload="loadData"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ListTourDays from './components/List.vue'
import SchedulePopup from '../../components/popups/Schedule.vue'
import { getTourDays } from '@/services/tour'
import TYPE from '@/data/type'

import ImportExcelButton from '../../components/buttons/ImportExcel.vue'
import ExportExcelButton from '../../components/buttons/ExportExcel.vue'

export default {
  name: 'TourDays',
  components: {
    ListTourDays,
    SchedulePopup,
    ImportExcelButton,
    ExportExcelButton
  },
  data() {
    return {
      loading: false,
      allArtifacts: [],
      selectedTourDay: null,
      activeTab: 'tour_day',
      total: 0,
      limit: 10,
      page: 1,
      searchText: '',
      formVisible: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    params() {
      return {
        page: this.page,
        per_page: this.limit,
        locale: this.language
      }
    },
    excelColumns() {
      const eColumns = this.$route.meta.data.index.excelColumns
      return (eColumns || []).map((c) =>
        TYPE.EXCEL_COLUMNS.find((column) => c === column.key)
      )
    },
    importExportTitles() {
      return [{ name: 'Lịch trình', value: 'tour_day' }]
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    ...mapActions('public', []),

    loadData() {
      this.loading = true
      this.formVisible = false
      getTourDays(this.params).then((response) => {
        this.allArtifacts = response.result
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    createTag() {
      this.selectedTourDay = null
      this.formVisible = true
    },
    updateTag(data) {
      this.selectedTourDay = data
      this.formVisible = true
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    handleReloadAfterDelete() {
      if (this.allArtifacts.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.tour-days-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 200px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
}
</style>
